module.exports = __webpack_public_path__ + "2241fc57c001daae2fbc3b2207257d61.svg";